import { addDays, format } from "date-fns";

const ExpDateAndResultInReports = ({ userDetail, user }) => {
  return (
    <div>
      <table className="table">
        <tbody>
          <tr className="fw-bold">
            <td className="border border-dark text-dark fontSize-13  border-top-0  text-uppercase text-center">
              Expiry Date{" "}
            </td>
            <td className="fontSize-13 border border-top-0 border-dark">
              {format(
                addDays(new Date(user?.createdAt || new Date()), 90),
                "dd MMM yyyy",
              )}
            </td>
          </tr>

          <td
            colSpan={3}
            style={{ height: "50px" }}
            className="border border-top-0 border-dark"
          >
            <p
              className=" m-0 p-0 fst-italic text-dark ps-2 my-1"
              style={{ lineHeight: "12px", fontSize: "10px" }}
            >
              Mentioned above is the medical report for Mr./Mrs.{" "}
              <span style={{ fontStyle: "normal" }} className="text-uppercase ">
                {userDetail?.user?.f_name}
              </span>
              ,<span className="d-block" />
              Who is
              <span
                className="fw-bold text-uppercase fs-6 fst-normal p-0 m-0"
                style={{
                  color: `${
                    userDetail?.user?.status === 1
                      ? "black"
                      : userDetail?.user?.status === 2
                        ? "#5cb85c"
                        : userDetail?.user?.status === 3
                          ? "red"
                          : userDetail?.user?.status === 4 && "#0000FF"
                  }`,
                }}
              >
                {userDetail?.user?.status === 1 && ` PROCESSING`}
                {userDetail?.user?.status === 2 && ` FIT`}
                {userDetail?.user?.status === 3 && ` UNFIT`}
                {userDetail?.user?.status === 4 && ` HELD UP`}
              </span>{" "}
              for the above mentioned job according to the medical criteria.{" "}
            </p>
          </td>
        </tbody>
      </table>

      {/* remarks will not show for Individual test  */}
      {/**/}
      {/* {user?.role_id !== 5 && ( */}
      {/*   <div className="text-dark text-uppercase fw-bold"> */}
      {/*     Remarks : */}
      {/*     <span */}
      {/*       className={`border-0 py-1 text-start ps-2 text-danger`} */}
      {/*       colSpan={2} */}
      {/*     > */}
      {/*       {physicalRemarksItem?.result || ""}{" "} */}
      {/*       {physicalRemarksItem?.result && */}
      {/*         physicalRemarksItem?.result !== "N/A" && */}
      {/*         physicalRemarksItem?.investigation?.investigation_tests[0]?.uom */}
      {/*           ?.name} */}
      {/*       {physicalRemarksItem?.result && */}
      {/*         (userDetail?.user?.status === 4 || */}
      {/*           userDetail?.user?.status === 3) && */}
      {/*         " & "} */}
      {/*       {userDetail?.user?.status === 4 && */}
      {/*         "THIS PERSON NEED MEDICALLY TREATMENT"} */}
      {/*       {userDetail?.user?.status === 3 && "THIS PERSON MEDICALLY UNFIT"} */}
      {/*     </span> */}
      {/*   </div> */}
      {/* )} */}
    </div>
  );
};
export default ExpDateAndResultInReports;
